import { Markups } from '../../components';
import { useAppSelector } from '../../redux/hooks';

export const MarkupsView = () => {
  const markupList = useAppSelector(state => state.employer.employerInfo.faGroups);
  const faq = useAppSelector(state => state.content.content.faqListMarkups);
  const ingress = useAppSelector(state => state.content.content.ingressMarkups);

  return <Markups markupList={markupList} faq={faq} ingress={ingress} />;
};
